import React from 'react'

function HomeHeader() {
  return (
    // <!-- HOME SECTION HEADER -->
    <header id="home-section">
      <div className="container">
        <div className="display-4 d-flex justify-content-center">
          Welcome to movie4u
        </div>
      </div>
    </header>
  )
}

export default HomeHeader
